class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.cachedResults = {};
		this.input = this.querySelector('input[type="search"]');
		this.resultsContainer = this.querySelector('[data-predictive-search]');
		this.isOpen = false;
		this.overlay = document.querySelector('.predictive-search-overlay');

		this.setupEventListeners();
	}

	setupEventListeners() {
		const form = this.querySelector('form');
		form.addEventListener('submit', (e) => {
			if (!this.input.value.trim()) e.preventDefault();
		});

		// Debounce to prevent API spam
		this.input.addEventListener('input', this.debounce(() => {
			this.onChange();
		}, 300));

		this.input.addEventListener('focus', () => this.onChange());

		this.overlay.addEventListener('click', () => {
			this.close();
		});
		this.addEventListener('keyup', (e) => this.onKeyup(e));
		this.addEventListener('keydown', (e) => {
			if (e.code === 'ArrowUp' || e.code === 'ArrowDown') e.preventDefault();
		});
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			return;
		}
		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.toLowerCase();
		this.setAttribute('loading', 'true');

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			return;
		}

		const types = this.dataset.types || 'product';
		const limit = this.dataset.limit || 5;

		const params = new URLSearchParams({
			q: searchTerm,
			'resources[type]': types,
			'resources[limit]': limit,
			'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku',
			section_id: 'predictive-search'
		});

		fetch(`${window.routes.predictive_search_url}?${params.toString()}`)
			.then(res => {
				if (!res.ok) throw new Error();
				return res.text();
			})
			.then(text => {
				const html = new DOMParser().parseFromString(text, 'text/html');
				const resultsMarkup = html.querySelector('[id$="predictive-search"]').innerHTML;
				this.cachedResults[queryKey] = resultsMarkup;
				this.renderSearchResults(resultsMarkup);
			})
			.catch(() => this.close())
			.finally(() => this.removeAttribute('loading'));
	}

	renderSearchResults(markup) {
		this.resultsContainer.innerHTML = markup;


		document.documentElement.classList.add("mb-scroll-locked");

		document.dispatchEvent(new CustomEvent('shopify:section:load', {
			bubbles: true,
			detail: { sectionId: 'predictive-search' }
		}));

		document.class

		this.setAttribute('open', 'true');
		this.isOpen = true;
		this.overlay.setAttribute('aria-hidden', 'false');

	}

	close() {
		this.removeAttribute('open');
		this.isOpen = false;
		document.documentElement.classList.remove("mb-scroll-locked");
		if (this.overlay) {
			this.overlay.setAttribute('aria-hidden', 'true');
		}
	}

	onKeyup(event) {
		switch (event.code) {
			case 'ArrowUp': this.switchOption('up'); break;
			case 'ArrowDown': this.switchOption('down'); break;
			case 'Enter':
				const selected = this.querySelector('[aria-selected="true"] a');
				if (selected) selected.click();
				break;
			case 'Escape': this.close(); break;
		}
	}

	switchOption(direction) {
		const all = Array.from(this.querySelectorAll('.my-custom-card'));
		if (!all.length) return;

		const current = this.querySelector('[aria-selected="true"]');
		let index = all.indexOf(current);

		if (direction === 'down') {
			index = index === all.length - 1 ? 0 : index + 1;
		} else {
			index = index <= 0 ? all.length - 1 : index - 1;
		}

		if (current) current.setAttribute('aria-selected', 'false');
		all[index].setAttribute('aria-selected', 'true');
		all[index].scrollIntoView({ block: 'nearest' });
	}
}

customElements.define('predictive-search', PredictiveSearch);